import React, { useState, useEffect } from 'react';
import { collection, query, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../../firebase';
import { Link } from 'react-router-dom';
import '../event/archive_event.css';

const ArchiveNewsList = () => {
  const [news, setNews] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchArchive = async () => {
      try {
        // Query your target archive collection sorted by date descending (Newest first)
        const q = query(collection(db, "parmNews"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        
        const archiveList = snap.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        
        setNews(archiveList);
      } catch (err) {
        console.error("Error fetching event archives:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchArchive();
  }, []);

  if (loading) return <div className="loader">Loading PArM Archives...</div>;

  return (
    <section className="archive-event-section">
      <div className="archive-event-container">
        <h2>PArM Past News Archive</h2>
        <p>Explore our historical roadmap of professional initiatives and milestones.</p>
        
        {news.length === 0 ? (
          <p className="archive-no-events">No archived news found.</p>
        ) : (
          <div className="archive-event-grid">
            {news.map((news) => (
              // 🟢 Link targets /archive/event_001 dynamically
              <Link to={`/archive-news-detail-parm/${news.news_id}`} key={news.id} className="archive-card">
                <div className="archive-event-card-content">
                  {/* Optional: Add a thumbnail element if you store an event cover image */}
                  {news.news_cover && <img src={news.news_cover} alt={news.news_title} className="archive-card-thumbnail" />}
                  
                  <h3>{news.news_title}</h3>
                  <p className="archive-event-date">
                    📅 {news.createdAt?.seconds 
                      ? new Date(news.createdAt.seconds * 1000).toLocaleDateString('en-MY', { year: 'numeric', month: 'long', day: 'numeric' })
                      : news.createdAt}
                  </p>
                  <span className="archive-view-more-btn">View Details ➔</span>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default ArchiveNewsList;